import { BaseModel } from "../base.model";

export class Workflow extends BaseModel {
  id: number;
  name: string;
  description: string;
}
